<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
    :close-on-press-escape="false" custom-class="client-error-dialog">
    <div class="error-content">
      <div class="error-header">
        <el-alert title="客户端连接异常" type="warning" show-icon :closable="false">
        </el-alert>
      </div>
      <div class="error-subtitle">您可以尝试以下方式解决</div>
      <div class="solution-box">
        <img src="../../../static/img/downLoadApp.png" alt="解决方案" />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleDownload">下载客户端</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/assets/js/api'

export default {
  name: 'ClientErrorDialog',
  data () {
    return {
      dialogVisible: false,
      downloadUrl: ''
    }
  },
  mounted () {
    // 监听全局事件
    this.$EventBus.$on('showClientErrorDialog', this.show)
  },
  beforeDestroy () {
    // 移除事件监听
    this.$EventBus.$off('showClientErrorDialog', this.show)
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    handleCancel () {
      this.dialogVisible = false
    },
    handleDownload () {
      api.menu.downloadClient().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.message);
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.error-content {
  text-align: center;
  padding: 0 20px;


}

.error-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;


}

.error-title {
  font-size: 16px;
  color: #303133;
}

.error-subtitle {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}

.solution-box {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 20px;
  background: #FAFAFA;

}

.solution-box img {
  max-width: 100%;
  height: auto;
}

.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ClientErrorDialog.vue